import { googlePlacesGeocode } from "../geocode";
import { getGooglePlacesDetails } from "../get-details";
import { getGooglePlacesSessionToken } from "../session-token";
import { type GooglePlacesAddress } from ".";

export async function getGooglePlacesAddressDetails(
  placeId: string,
  options?: { useSessionToken?: boolean },
) {
  const sessionToken =
    options?.useSessionToken && getGooglePlacesSessionToken();

  const addressComponents = (
    sessionToken
      ? await getGooglePlacesDetails({
          fields: ["address_components"],
          placeId,
          sessionToken,
        })
      : // Geocoder API is cheaper than Places API for single requests,
        // so use it if an active session is not available
        await googlePlacesGeocode(placeId, { region: "us" })
  ).address_components as google.maps.GeocoderAddressComponent[];

  return addressComponents.reduce<GooglePlacesAddress>((address, component) => {
    if (component.types.includes("locality")) {
      address.city = component.long_name;
    } else if (component.types.includes("postal_code")) {
      address.postalCode = component.long_name;
    } else if (component.types.includes("administrative_area_level_1")) {
      address.stateCode = component.short_name;
    } else if (component.types.includes("route")) {
      address.street = component.long_name;
    } else if (component.types.includes("street_number")) {
      address.streetNumber = component.long_name;
    } else if (component.types.includes("sublocality") && !address.city) {
      address.city = component.long_name;
    } else if (component.types.includes("subpremise")) {
      address.apartment = component.short_name;
    }

    return address;
  }, {});
}
